module.exports = __webpack_public_path__ + "img/電気回路_2_1_4.6890e4e9.png";